/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Su_SubInputs */

const en_funnel_su_sub = /** @type {(inputs: Funnel_Su_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save it to your account.`)
};

const es_funnel_su_sub = /** @type {(inputs: Funnel_Su_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guárdala en tu cuenta.`)
};

/**
* | output |
* | --- |
* | "Save it to your account." |
*
* @param {Funnel_Su_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_su_sub = /** @type {((inputs?: Funnel_Su_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Su_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_su_sub(inputs)
	return en_funnel_su_sub(inputs)
});